<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("drivers")}}</h4>
                <p class="text-subtitle-1">{{$t("list_of_drivers")}}</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-2">
            <v-col cols="12" md="3" v-if="hasPermission(permissions.driver.create)">
                <v-btn block color="primary" @click="$router.push({ name: 'DriverCreate' })">
                    <v-icon left>mdi-plus</v-icon>
                    {{$t("new_driver")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            block 
                            depressed 
                            v-on="on"
                            v-bind="attrs">
                            <v-icon left>mdi-magnify</v-icon>
                            {{$t("search")}}
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>{{$t("search")}}</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        :label="$t('name')"
                                        v-model="form.name"
                                        @keypress.enter="fetchDriversWithSearch"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        clearable
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        :label="$t('phone')"
                                        v-model="form.phone"
                                        @keypress.enter="fetchDriversWithSearch"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        clearable
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-row no-gutters>
                                <v-col>
                                    <v-btn block color="primary" @click="fetchDriversWithSearch">
                                        {{$t("submit")}}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="items"
                    :loading="loading"
                    :options.sync="options"
                    :page.sync="page"
                    disable-sort
                    :footer-props="footerProps"
                    :server-items-length="serverItemsLength"
                >
                    <template v-slot:[`item.name`]="{item}">
                        <v-btn icon @click="handleClickRow(item)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.name}}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import authorize from '../../utils/authorize';
import service from "./../../services/fleet/driver";
import permissions from '../../data/permissions';

export default {
    name: "DriversListView",
    data() {
        return {
            footerProps: {
                'items-per-page-options': [10, 25, 50]
            },
            items: [],
            loading: false,
            options: {},
            serverItemsLength: 0,
            form: {
                name: "",
                phone: ""
            },
            page: 1,
            permissions
        }
    },
    watch: {
        options() {
            this.fetchDrivers()
        }
    },
    computed: {
        headers() {
            return [
                { text: this.$t("name"), value: "name" },
                { text: this.$t("phone"), value: "phone" },
            ]
        },
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        fetchDrivers() {
            this.items = [];
            this.loading = true;
            service.list({...this.options, ...this.form}).then(response => {
                this.items = response.data.drivers;
                this.serverItemsLength = response.data.total;
            }).finally(() => {
                this.loading = false;
            })
        },
        fetchDriversWithSearch() {
            this.page = 1;
            this.fetchDrivers();
        },
        handleClickRow(item) {
            this.$router.push({ name: "DriverDisplay" , params: { driverID : item.id } })
        }
    },
    created() {
        
    }
}
</script>

<style>

</style>